import { render, staticRenderFns } from "./ActivityRule.vue?vue&type=template&id=0d50d884&scoped=true&"
import script from "./ActivityRule.vue?vue&type=script&lang=js&"
export * from "./ActivityRule.vue?vue&type=script&lang=js&"
import style0 from "./ActivityRule.vue?vue&type=style&index=0&id=0d50d884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d50d884",
  null
  
)

export default component.exports